import { render, staticRenderFns } from "./Direccion.vue?vue&type=template&id=2a217bf5&scoped=true"
import script from "./Direccion.vue?vue&type=script&lang=js"
export * from "./Direccion.vue?vue&type=script&lang=js"
import style0 from "./Direccion.vue?vue&type=style&index=0&id=2a217bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a217bf5",
  null
  
)

export default component.exports